export default __webpack_public_path__ + "static/media/refresh-cw-blue.d865fda8.svg";